import {
  _delete, _get, _patch, _save,
  getUrlQueryParameterFromObject,
} from 'frontcore/utils/communications/apiClient'
import { _saveBinary } from './apiClient'

export const URL_BASE_IMPROVEMENT_IDEAS = 'improvement-ideas'
export const URL_BASE_IMPROVEMENT_IDEAS_FROM_ANOTHER_IDEA = 'improvement-idea-from-parent'
export const URL_BASE_IMPROVEMENT_IDEA_CATEGORIES = 'improvement-idea-categories'
const CHECKPOINT_ASSESSMENT = 'task_manager_assessment'
const DAILY_ROUND_ASSESSMENT = 'daily_round_assessment'
const GEMBA_WALK_ASSESSMENT = 'gemba_walk_assessment'
const KPI_CARD = 'kpi_card'
const OK_FIRST_PART = 'ofp_assessment'
const URL_BASE_STATS = 'stats'

/**
 * @param { string } url - URL string
 * @param { Record<string, string> | undefined } [headers=undefined] - Header configuration
 * @returns { Promise<ImprovementIdea[]> }
*/
export function getImprovementIdeas (params) {
  const queryParams = getUrlQueryParameterFromObject(params, false)
  const url = queryParams ? `${URL_BASE_IMPROVEMENT_IDEAS}/?${queryParams}` : `${URL_BASE_IMPROVEMENT_IDEAS}/`
  return _get(url)
}

export function getImprovementIdeasByIds (ids, format = 'expanded') {
  const url = `${URL_BASE_IMPROVEMENT_IDEAS}/?ids=` + ids.join(',') + `&format=${format}`
  return _get(url)
}

export function getDailyRoundImprovementIdeas (assessmentId) {
  return getImprovementIdeas({ [DAILY_ROUND_ASSESSMENT]: assessmentId })
}

export function getGembaWalkImprovementIdeas (assessmentId) {
  return getImprovementIdeas({ [GEMBA_WALK_ASSESSMENT]: assessmentId })
}

export function getOFPImprovementIdeas (assessmentId) {
  return getImprovementIdeas({ [OK_FIRST_PART]: assessmentId })
}

export function getTMImprovementIdeas (assessmentId) {
  return getImprovementIdeas({ [CHECKPOINT_ASSESSMENT]: assessmentId })
}

export function getKpiCardImprovementIdeas (kpiCardId) {
  return getImprovementIdeas({ [KPI_CARD]: kpiCardId })
}

export function getImprovementIdeaById (id, params) {
  const queryParams = getUrlQueryParameterFromObject(params, false)
  const url = queryParams ? `${URL_BASE_IMPROVEMENT_IDEAS}/${id}/?${queryParams}` : `${URL_BASE_IMPROVEMENT_IDEAS}/${id}/`
  return _get(url)
}

export function patchImprovementIdeaById (id, data) {
  const url = `${URL_BASE_IMPROVEMENT_IDEAS}/${id}/?format=expanded`
  return _patch(url, data)
}

export function saveImprovementIdea (data) {
  const url = `${URL_BASE_IMPROVEMENT_IDEAS}/`
  return _save(url, data, true)
}

export function saveImprovementIdeaFromAnotherIdea (data) {
  const url = `${URL_BASE_IMPROVEMENT_IDEAS_FROM_ANOTHER_IDEA}/`
  return _save(url, data, true)
}

export function deleteImprovementIdeaById (id) {
  const url = `${URL_BASE_IMPROVEMENT_IDEAS}/${id}/`
  return _delete(url)
}

export function getImprovementIdeaHistory (id) {
  const url = `${URL_BASE_IMPROVEMENT_IDEAS}/${id}/history/`
  return _get(url)
}

export function getImprovementIdeasPercentageStats (params) {
  const queryParams = getUrlQueryParameterFromObject(params, false)
  let url = `${URL_BASE_STATS}/${URL_BASE_IMPROVEMENT_IDEAS}/datasets/status-percentage/`
  url = queryParams ? `${url}?${queryParams}` : url
  return _get(url)
}

export function getImprovementIdeasStats (params) {
  const queryParams = getUrlQueryParameterFromObject(params, false)
  let url = `${URL_BASE_STATS}/${URL_BASE_IMPROVEMENT_IDEAS}/datasets/stats/`
  url = queryParams ? `${url}?${queryParams}` : url
  return _get(url)
}

export function getImprovementIdeasStatusGraph (params) {
  const queryParams = getUrlQueryParameterFromObject(params, false)
  let url = `${URL_BASE_STATS}/${URL_BASE_IMPROVEMENT_IDEAS}/datasets/graphs/`
  url = queryParams ? `${url}?${queryParams}` : url
  return _get(url)
}

export function getImprovementIdeasExcel (params) {
  const queryParams = getUrlQueryParameterFromObject(params, false)
  const url = `${URL_BASE_IMPROVEMENT_IDEAS}/?${queryParams}`
  return _saveBinary(url)
}

export function fetchImprovementIdeaCategories () {
  const url = `${URL_BASE_IMPROVEMENT_IDEA_CATEGORIES}/`
  return _get(url)
}
